import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import Navbar from "../Navbar";
import { documentService } from "../../../../services/document.services";
import { downloadDocument } from "../../../../helpers/documentFile";
import DocumentFileIcon from "../../../GlobalComponents/DocumentFileIcon";

// Documents uploaded by the office, reps can only view and download
const Index = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const [documents, setDocuments] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!user || user.data.user_role !== "reps") return;

        documentService
            .getList()
            .then((res) => {
                setDocuments(res?.data || []);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error: ", error);
                setLoading(false);
            });
    }, []);

    if (!user || user.data.user_role !== "reps") {
        return <Redirect to="/" />;
    }

    return (
        <div>
            <Navbar activePage="documents" />
            <div className="container">
                <div className="pt-4 row align-items-center">
                    <div className="col-md-12">
                        <div className="sub-menu">
                            <h1 className="heading">Documents</h1>
                        </div>
                    </div>
                </div>
                <div className="table-scroll mt-4">
                    <table className="main-table">
                        <thead>
                            <tr>
                                <th scope="col" style={{ minWidth: "50%" }}>Title</th>
                                <th scope="col">File</th>
                                <th scope="col" className="text-right">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {documents.map((doc) => (
                                <tr key={doc._id}>
                                    <td>
                                        <strong>{doc.title}</strong>
                                    </td>
                                    <td>{doc.original_name}</td>
                                    <td className="text-right text-nowrap">
                                        <DocumentFileIcon doc={doc} />
                                        <button className="btn btn-default btn-sm" onClick={() => downloadDocument(doc)}>
                                            Download
                                        </button>
                                    </td>
                                </tr>
                            ))}

                            {documents.length === 0 && (
                                <tr className="text-center">
                                    <td colSpan="3">{loading ? "Loading..." : "No Record Found"}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Index;
